import { useNavigate, useParams } from 'react-router';
import './PaymentPage.scss';

const PaymentPending = () => {
  const navigate = useNavigate();

  return (
    <div className="alert-box pending shadow-sm text-center bg-white p-5 rounded-3 border">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="48px"
        viewBox="0 0 24 24"
        width="48px"
        fill="#f0ad4e"
        className="mb-3"
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M12 4a8 8 0 1 1-8 8c0-4.41 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm.5 5H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" />
      </svg>

      <h4 className="mb-3 text-warning">Your payment is pending</h4>
      <p className="mb-4 text-muted">
        We haven't received confirmation yet. We will update your payment status
        shortly.
      </p>

      <button
        className="btn btn-outline-primary"
        onClick={() => navigate('/dashboard')}
      >
        Go to Dashboard
      </button>
    </div>
  );
};

export default PaymentPending;
